import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from '../../api/axios-tibbaa';
import { getRegion } from '../../helpers/getRegion';
import { getTranslation } from '../../constants/translations';
import Loader from '../../components/Loader/Loader';

import './Acceptation.scss';

export const Acceptation = () => {
  const [serchParams] = useSearchParams();
  const navigate = useNavigate();
  const [isPolicy, setPolicy] = useState(false);
  const [isTerms, setTerms] = useState(false);
  const [isLoading, setLoading] = useState(false);

  const root = document.getElementById('root');
  const domen = getRegion();
  const t = getTranslation();
  const token = serchParams.get('token');

  if (root) {
    root.dataset.theme = domen;
  }

  if (!token) {
    navigate('/');
  }

  const handleSubmit = async () => {
    setLoading(true);

    try {
      await axios.get(`/Users/StartDataMigration/${token}`);

      window.location.href = 'https://launch.sixtix.nl/';
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <section className="acceptation">
      <div className="_container acceptation__container">
        <h2 className="acceptation__title">{t.acceptation.title}</h2>
        <div className="acceptation__chekboxes-container">
          <div className="checkbox">
            <input
              type="checkbox"
              id="policy"
              checked={isPolicy}
              onChange={() => setPolicy(!isPolicy)}
            />
            <label htmlFor="policy">
              <svg viewBox="0,0,50,50">
                <path d="M5 30 L 20 45 L 45 5"></path>
              </svg>
            </label>
            <p>
              {t.acceptation['I accept ']}
              <a
                href={`https://sixtix.${domen}/documents/SIXTIX_NL_Privacyverklaring_2025_NL_v24_07_25.pdf`}
                target="_blank"
                rel="noreferrer"
                className="acceptation__link"
              >
                {t.common.policy}
              </a>
            </p>
          </div>

          <div className="checkbox">
            <input
              type="checkbox"
              id="terms"
              checked={isTerms}
              onChange={() => setTerms(!isTerms)}
            />
            <label htmlFor="terms">
              <svg viewBox="0,0,50,50">
                <path d="M5 30 L 20 45 L 45 5"></path>
              </svg>
            </label>
            <p>
              {t.acceptation['I accept ']}
              <a
                href={`https://sixtix.${domen}/documents/ALGEMENE_GEBRUIKSVOORWAARDEN_GEBRUIKER_LOGIN_SIXTIX_NL.pdf`}
                target="_blank"
                rel="noreferrer"
                className="acceptation__link"
              >
                {t.common.terms}
              </a>
            </p>
          </div>
        </div>

        <button
          onClick={handleSubmit}
          className="acceptation__submit button"
          disabled={!isPolicy || !isTerms}
        >
          {t.acceptation.submit}
        </button>
      </div>
    </section>
  );
};
